import { getProductsByType } from '@repo/accounts-services'
import { defineSagaForService } from '@repo/core'
import { productsByTypeDataActions } from '../../../../slices'

export const serviceConfig = defineSagaForService({
  [productsByTypeDataActions.getRequest.type]: {
    apiClientDomain: 'accounts',
    service: getProductsByType,
    getError: (error) => error.response?.data || error.message,
    actionTypeResponse: productsByTypeDataActions.getResponse.type,
    actionTypeRequest: productsByTypeDataActions.getRequest.type,
  },
  [productsByTypeDataActions.refreshRequest.type]: {
    apiClientDomain: 'accounts',
    service: getProductsByType,
    getError: (error) => error.response?.data || error.message,
    actionTypeResponse: productsByTypeDataActions.refreshResponse.type,
    actionTypeRequest: productsByTypeDataActions.refreshRequest.type,
  },
})
